import { render, staticRenderFns } from "./EditTemperaturePerProduct.vue?vue&type=template&id=6ab1e6d8&scoped=true&"
import script from "./EditTemperaturePerProduct.vue?vue&type=script&lang=js&"
export * from "./EditTemperaturePerProduct.vue?vue&type=script&lang=js&"
import style0 from "./EditTemperaturePerProduct.vue?vue&type=style&index=0&id=6ab1e6d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab1e6d8",
  null
  
)

export default component.exports